var map = {
	"./2019-01-31-whats-new-in-journeyapps-january-2019/index.markdown": 18737,
	"./2019-02-04-shifting-from-project-product-management-age-software/index.markdown": 86378,
	"./2019-03-01-age-of-software-digital-turning-point/index.markdown": 19880,
	"./2019-03-05-what-every-business-case-digital-transformation-should/index.markdown": 54036,
	"./2019-04-01-journeyapps-platform-hardware-integration-engine/index.markdown": 67419,
	"./2019-04-09-5-unique-features-make-journeyapps-most-agile-market/index.markdown": 23147,
	"./2019-04-11-shifting-from-maintenance-innovation/index.markdown": 72866,
	"./2019-04-23-building-capacity-innovation/index.markdown": 94235,
	"./2019-06-04-making-sense-digital-transformation/index.markdown": 65612,
	"./2019-06-19-why-agility-especially-important-industrial-companies/index.markdown": 66748,
	"./2019-07-02-navigating-digital-transformation-oil-gas-industry/index.markdown": 78013,
	"./2019-07-18-which-industries-most-digital-why/index.markdown": 71823,
	"./2019-07-22-5-surprising-things-digitization-oil-gas/index.markdown": 50587,
	"./2019-07-26-massive-opportunity-digitization-engineering/index.markdown": 93178,
	"./2019-07-31-whats-new-in-journeyapps-july-2019/index.markdown": 62635,
	"./2019-08-08-7-strategies-oilfield-service-companies-survive/index.markdown": 66574,
	"./2019-08-15-swings-roustabouts-episode-1-history-price-cycles-oil/index.markdown": 49324,
	"./2019-08-20-oh-crap-i-just-broke-excel-young-production-engineer/index.markdown": 46629,
	"./2019-08-23-swings-roustabouts-ep-3-oilfield-services-where-we-now/index.markdown": 92623,
	"./2019-08-29-swings-roustabouts-ep-4-current-reality-midstream-oil/index.markdown": 57383,
	"./2019-09-05-swings-roustabouts-ep-5-stepping-future-digital-20/index.markdown": 62963,
	"./2019-09-12-swings-roustabouts-ep-6-midstream-oil-gas-new-digital/index.markdown": 3525,
	"./2019-09-19-swings-roustabouts-ep-7-five-challenges-digital-oil-gas/index.markdown": 62083,
	"./2019-09-30-whats-new-in-journeyapps-september-2019/index.markdown": 12585,
	"./2019-10-10-ui-ux-tips-optimizing-apps-industrial-environments/index.markdown": 65899,
	"./2019-10-15-webinar-7-key-takeaways/index.markdown": 56703,
	"./2019-10-24-low-code-platforms-move-mountains-small-software-teams/index.markdown": 11203,
	"./2019-10-31-whats-new-in-journeyapps-october-2019/index.markdown": 7893,
	"./2019-11-07-how-choose-between-nfc-rfid-industrial-asset-tracking/index.markdown": 2566,
	"./2019-11-14-iiot-field-apps-future-of-industrial-connected-worker/index.markdown": 89164,
	"./2019-11-15-citizen-data-scientist-lauren/index.markdown": 49141,
	"./2019-11-19-journeyapps-gains-momentum-fortune-500-customers/index.markdown": 70523,
	"./2019-12-05-emergence-of-event-streaming-software-defined-world/index.markdown": 44143,
	"./2019-12-12-forward-looking-cios-flexibility-no-code-low-code-pro-code/index.markdown": 96726,
	"./2019-12-18-10-challenges-facing-low-code-platforms/index.markdown": 16914,
	"./2019-12-31-whats-new-in-journeyapps-highlights-2019/index.markdown": 62600,
	"./2020-01-16-connecting-workers-iiot-field-apps/index.markdown": 90707,
	"./2020-01-28-industrial-companies-buying-software-companies-forbes/index.markdown": 20542,
	"./2020-01-30-successfully-transforming-into-agile-organization/index.markdown": 22975,
	"./2020-02-06-digital-app-strategy-buy-a-platform-part-1/index.markdown": 26316,
	"./2020-02-13-digital-app-strategy-buy-a-platform-part-2/index.markdown": 71511,
	"./2020-02-27-business-app-development-reality-it-teams/index.markdown": 92678,
	"./2020-03-01-whats-new-in-journeyapps-february-2020/index.markdown": 24862,
	"./2020-03-13-covid-19-our-response/index.markdown": 3697,
	"./2020-03-13-low-code-app-development-basics/index.markdown": 50568,
	"./2020-04-02-journeyapps-provides-free-access-covid-19-apps/index.markdown": 86354,
	"./2020-04-03-low-code-pricing-how-to-fix-it/index.markdown": 56154,
	"./2020-04-09-whats-new-in-journeyapps-april-2020/index.markdown": 24877,
	"./2020-04-24-enhancing-self-service-capabilities-web-apps/index.markdown": 11852,
	"./2020-05-08-preparing-for-recession-reduce-it-costs-app-development-platform/index.markdown": 17912,
	"./2020-05-20-why-journeyapps-developers-perspective/index.markdown": 81296,
	"./2020-05-29-low-code-road-to-software-enlightenment-part-1/index.markdown": 5457,
	"./2020-06-01-whats-new-in-journeyapps-may-2020/index.markdown": 7180,
	"./2020-06-19-low-code-road-to-software-enlightenment-part-2/index.markdown": 97928,
	"./2020-07-01-whats-new-in-journeyapps-july-2020/index.markdown": 45666,
	"./2020-07-23-saving-development-time-cost-build-apps-once/index.markdown": 23299,
	"./2020-08-20-limitations-of-form-and-workflow-builders/index.markdown": 74324,
	"./2020-09-03-low-code-road-to-software-enlightenment-part-3/index.markdown": 21787,
	"./2020-09-08-no-code-vs-pro-code-a-new-hope/index.markdown": 7751,
	"./2020-09-09-journeyapps-launches-oxide-new-paradigm-business-apps/index.markdown": 70992,
	"./2020-09-24-low-code-road-to-software-enlightenment-part-4/index.markdown": 67155,
	"./2020-10-22-whats-new-in-journeyapps-october-2020/index.markdown": 60865,
	"./2020-10-26-case-study-reduce-development-time-10x/index.markdown": 24121,
	"./2020-12-11-whats-new-in-journeyapps-december-2020/index.markdown": 6812,
	"./2020-12-16-how-journeyapps-makes-customized-integrations-fast-easy/index.markdown": 42402,
	"./2020-12-31-whats-new-in-journeyapps-highlights-2020/index.markdown": 47084,
	"./2021-03-31-whats-new-in-journeyapps-march-2021/index.markdown": 81516,
	"./2021-05-17-whats-new-in-journeyapps-may-2021/index.markdown": 732,
	"./2021-06-30-whats-new-in-journeyapps-june-2021/index.markdown": 34873,
	"./2021-07-07-design-voice-controlled-apps-for-realwear/index.markdown": 50173,
	"./2021-08-04-whats-new-in-journeyapps-august-2021/index.markdown": 13445,
	"./2021-10-07-whats-new-in-journeyapps-october-2021/index.markdown": 97992,
	"./2021-12-23-whats-new-in-journeyapps-highlights-2021/index.markdown": 56967,
	"./2022-02-10-journeyapps-launches-updated-branding/index.markdown": 48674,
	"./2022-03-31-whats-new-in-journeyapps-march-2022/index.markdown": 9144,
	"./2022-08-01-whats-new-in-journeyapps-july-2022/index.markdown": 4655,
	"./2022-11-24-whats-new-in-journeyapps-november-2022/index.markdown": 35394,
	"./2022-12-22-whats-new-in-journeyapps-highlights-2022/index.markdown": 49236,
	"./2023-04-20-whats-new-in-journeyapps-april-2023/index.markdown": 11476,
	"./2023-08-24-whats-new-in-journeyapps-announcing-oxide-v2/index.markdown": 23817,
	"./2023-09-07-whats-new-in-journeyapps-september-2023/index.markdown": 16283,
	"./2024-04-25-whats-new-in-journeyapps-q1-2024/index.markdown": 25049,
	"./2024-12-10-whats-new-in-journeyapps-q4-2024/index.markdown": 91235,
	"./2025-10-14-next-era-of-the-platform/index.markdown": 16046,
	"./2025-10-29-ai-roadmap/index.markdown": 48643,
	"./2025-12-22-v5-release/index.mdx": 19956,
	"./2026-03-16-whats-new-in-journeyapps-march-2026/index.mdx": 57177,
	"./2026-03-18-sector-inside-oxide/index.mdx": 59616,
	"./2026-03-23-sector-filtering-and-relationship-workflows/index.mdx": 53854,
	"./2026-03-24-db-vs-api-vs-cc/index.mdx": 96862,
	"./2026-04-03-sector-updates/index.mdx": 35329,
	"./2026-04-07-container-improvements/index.mdx": 39215,
	"./2026-04-08-oxide-improvements/index.mdx": 61600,
	"./2026-04-17-new-docs-site/index.mdx": 35283,
	"./2026-04-22-platform-cli-for-ai-app-building/index.mdx": 915,
	"./2026-05-04-v5-0-releases/index.mdx": 29705,
	"./2026-05-05-v4-90-releases/index.mdx": 88190,
	"./2026-05-27-copilot-in-runtime-apps/index.mdx": 81483,
	"./2026-06-02-v5-1-releases/index.mdx": 29521,
	"./2026-07-09-oxide-evolved/index.mdx": 80732,
	"./2026-09-01-container-26-8-1-release/index.mdx": 37326,
	"./2026-10-05-microsoft-edge-support/index.mdx": 87239,
	"./2026-10-22-container-26-10-1-release/index.mdx": 12026,
	"./2026-10-26-emudhra-platform-security-updates/index.mdx": 60578
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79137;